import Header from "../Components/Header";
import Footer from "../Components/Footer";
import ScrollUp from "../Components/ScrollUp";
// import FeaSliderOne from "../Components/FeaSliderOne";
// import FeaSliderTwo from "../Components/FeaSliderTwo";

export default function Home() {



  return (
    <>
      <section id="scroll-up">

        {/* <!-- back-to-top-start  --> */}
        <ScrollUp />
        {/* <!-- back-to-top-end  --> */}

        <div className="float-header">
          <Header />
        </div>

        {/* <!-- Modal Pop-up Form --> */}
        <section className="Modal_live_demo">
          <div
            className="modal p-5 fade"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content border-0 rounded-4">
                <div className="modal-header">
                  <h5 className="modal-title text-white py-n2">
                    Schedule Your Live Demo
                  </h5>
                  <button
                    className="position-absolute custom_close_btn top-0 start-100 translate-middle"
                    type="button"
                    data-bs-dismiss="modal"
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div className="modal-body p-4">
                  <div>
                    <input
                      className="mt-2 py-2 border-0 border-bottom bg-transparent"
                      type="text"
                      placeholder="Enter Name"
                      name="Username"
                      required
                    />
                    <br />
                    <input
                      className="mt-4 py-2 border-0 border-bottom bg-transparent"
                      type="text"
                      placeholder="Enter Phone Number"
                      name="pass"
                      required
                    />
                    <br />
                    <select
                      className="mt-4 border-bottom text-black"
                      name=""
                      autoComplete=""
                      placeholder="Select The Nature Of Business"
                      required
                    >
                      <option value="1">Select Business Type</option>
                      <option value="TradingBusiness">Trading Business</option>
                      <option value="ManufactureBusiness">
                        Manufacture Business
                      </option>
                      <option value="ServiceRelatedBusiness">
                        Service Related Business
                      </option>
                      <option value="JewelleryRelatedBusiness">
                        Jewellery Related Business
                      </option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="header-bottom__btn d-flex align-items-center">
                    <a href="." className="custom_modal_btn me-2">
                      <span>Submit</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- Modal Pop-up Form End--> */}

        {/* <!-- 4 Card Modal --> */}
        <section className="Modal_cards_4">
          <div
            className="modal fade"
            id="exampleModal1"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content rounded-4">
                <div className="modal-header">
                  <h5 className="modal-title text-white py-n2">
                    Create GST/ Non GST Bills.
                  </h5>
                  <button
                    className="position-absolute custom_close_btn top-0 start-100 translate-middle"
                    type="button"
                    data-bs-dismiss="modal"
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div>
                    <div className="d-flex">
                      {/* <!-- <b><i className="fa-solid fa-angles-right fs-6 mt-1 pe-2 text-black"></i></b> --> */}
                      <p className="text-black">
                        {" "}
                        With effective GST billing features, Billwale billing
                        software helps you in creating a professional brand
                        identity. Invoices can be made using the Billwale
                        accounting and billing application.It enables you to
                        operate by Indian law regarding the Goods and Service
                        Tax.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        {" "}
                        With the Billwale app, accounting is error-free. It
                        assists in ensuring data security for your company. The
                        Billwale app's invoice styles make it simple to prepare
                        GST invoices.{" "}
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        Billwale app can be used offline as well as online.
                        Therefore, a SME can more easily comply with the best
                        accounting procedures by using the app. It simplifies
                        the bookkeeping procedure for companies.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        {" "}
                        Using our simple invoicing software to abide by GST
                        regulations. The billing software from Billwale offers a
                        number of practical billing options. In a few simple
                        steps, you can make invoices for your customers.{" "}
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        {" "}
                        Moreover, you can send them to customers by email,
                        print, or WhatsApp. They are available for printing in
                        A4, A5, 2, and 3 inch sizes from your printer.Unlike the
                        majority of accounting software, Billwale enables you to
                        produce invoices rapidly.{" "}
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        {" "}
                        The best part is that it is a simple process and won't
                        require hours of demanding training. To create
                        professional and distinctive bills, you may choose from
                        more than ten GST invoice and billing templates in the
                        software. (It features a design based on the accounting
                        software Tally.)
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        The simplest free GST invoicing software is Billwale. It
                        includes various useful billing and accountancy
                        capabilities. For SMEs, using the app makes business
                        management simple.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        Your business will differentiate out from competitors
                        with fully customized GST-compliant invoices.For
                        business owners, the best billing software automates the
                        billing process. Billwale has a specific Android app and
                        Windows software for this purpose.{" "}
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        Users of Android mobile devices can access the basic
                        functions needed for daily accounting for free. The only
                        cost for premium services for business owners is a
                        yearly subscription.Windows desktop software comes with
                        a lot of helpful features.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        They are available to all businesses for free during
                        their 15-day trial. Therefore, each company can test the
                        services before buying a subscription. It enables SMEs
                        to understand the app's advantages before making a
                        purchase.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade"
            id="exampleModal2"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content rounded-4">
                <div className="modal-header ">
                  <h5 className="modal-title text-white py-n2">
                    Manage Inventory Efficiently
                  </h5>
                  <button
                    className="position-absolute custom_close_btn top-0 start-100 translate-middle"
                    type="button"
                    data-bs-dismiss="modal"
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div>
                    <div className="d-flex">
                      <p className="text-black">
                        The best inventory management software Billwale has many
                        useful features for managing Inventory. enhances
                        performance in business. You may track the sales of your
                        company using features of the Billwale app which
                        includes business reports.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        It will make it easier to assess how well you have
                        managed your inventory.You can list and track things
                        using the inventory tracking features. The batch number,
                        expiration date, manufacturing date, slot number, and
                        other information are used for tracking.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        As soon as inventory arrive, the data are entered into
                        the system. It helps to have the necessary stock
                        available for sale when it's needed. It also helps in
                        maintaining a record to make sure that no theft goes
                        unreported.You can check the current status of your
                        inventory with the online billing software developed by
                        Billwale.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        Additionally, you can create notifications to notify
                        your suppliers of any new orders. Additionally, you can
                        use the delivery challan at any time to track the
                        position of packed orders.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        You can effortlessly complete all inventory tracking
                        duties using our inventory management app. It
                        contributes to better customer service.Using our simple
                        invoicing software to abide by GST regulations. The
                        billing software from Billwale offers a number of
                        practical billing options.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        In a few simple steps, you can make invoices for your
                        customers. Moreover, you can send them to customers by
                        email, print, or WhatsApp. They are available for
                        printing in A4, A5, 2, and 3 inch sizes from your
                        printer.Unlike the majority of accounting software,
                        Billwale enables you to produce invoices rapidly.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        The best part is that it is a simple process and won't
                        require hours of demanding training. To create
                        professional and distinctive bills, you may choose from
                        more than ten GST invoice and billing templates in the
                        software. (It features a design based on the accounting
                        software Tally.)
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        Your staff members may handle your inventory management
                        requirements with Billwale. It does this by utilizing a
                        variety of the app's functionality. You can use the fast
                        invoicing software to enter all the sales data that has
                        been stored in an excel sheet.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        It helps to reduce the time and effort needed for
                        various accounting procedures.You don't need to perform
                        activities manually when using the finest billing
                        software because it automates most operations.
                        Additionally, items are kept from going missing thanks
                        to frequent checks and data matching via app.
                      </p>
                    </div>
                    <div className="d-flex">
                      <p className="text-black">
                        To prevent business loss, restoration is an easy task to
                        complete instantly. It aids in meeting daily inventory
                        management needs.Having statistics on your sales is
                        another advantage of using Billwale software. You are
                        able to make GST reports using the app. You can plan a
                        strategy to increase profits and decrease costs.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade"
            id="exampleModal3"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content rounded-4">
                <div className="modal-header ">
                  <h5 className="modal-title text-white py-n2">
                    Get Real Time Analytics
                  </h5>
                  <button
                    className="position-absolute custom_close_btn top-0 start-100 translate-middle"
                    type="button"
                    data-bs-dismiss="modal"
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="d-flex">
                    <p className="text-black">
                      With the help of the Billwale dashboard, management is
                      simplified. Business cash flow, inventory status, open
                      orders, and payment updates are all viewed in one
                      location.
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="text-black">
                      You can manage your business utilizing a mobile device
                      with the help of free GST billing software and invoicing
                      solutions. With this free programme, accounting in your
                      business is made extremely simple and effective.
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="text-black">
                      Because all information is stored during billing.Using the
                      business dashboard, you can instantly receive detailed
                      updates about your company at any moment. Our software
                      also provides sufficient features, such as cash flow, bank
                      status, stock/inventory status, and open orders.
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="text-black">
                      A business dashboard simplifies the management process.
                      You can view the most recent company news, such as sales
                      in your stores. The GST billing app helps in business
                      operations analysis.You can reduce the amount of time
                      needed to manage your firm by using our software.
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="text-black">
                      You can promptly modify your business plan using the
                      observations. It guarantees the efficient operation of
                      your company. Using the free billing software, you can do
                      this.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade"
            id="exampleModal4"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content rounded-4">
                <div className="modal-header ">
                  <h5 className="modal-title text-white py-n2">
                    Quick E-Invoicing & E-Way Bill Generate
                  </h5>
                  <button
                    className="position-absolute custom_close_btn top-0 start-100 translate-middle"
                    type="button"
                    data-bs-dismiss="modal"
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="d-flex">
                    <p className="text-black">
                      Create E - Way and E - Invoice bills using the billwale
                      software in a few simple steps. The number of e-way bills
                      that can be produced using the online billing software is
                      not limited. The app also makes it simple to share the
                      bills via email or WhatsApp.
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="text-black">
                      There are four different sorts of E-Way bills that the
                      billing programme can produce: standard, bill to ship to,
                      bill from dispatch from, and a mix of the last two.
                      Invoices, credit notes, and delivery challans are just a
                      few of the transactions that can be used to create E-Way
                      bills using the Billwale software.
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="text-black">
                      According to the government's requirements, the billing
                      application notifies the user about transactions that
                      require such an e-way bill so that it can be immediately
                      generated. The filters allow users to sort transactions
                      that need an e-way bill and E - Invoicing.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- 4 Card Modal end--> */}

        {/* <!-- tp-offcanvus-area-start --> */}
        <div className="tpoffcanvas-area">
          <div className="tpoffcanvas">
            <div className="tpoffcanvas__close-btn">
              {/* <!-- <button className="position-absolute custom_close_btn top-0 start-100 translate-middle" type="button"><i className="fa-solid fa-xmark"></i></button> --> */}
              <button className="close-btn text-white">
                <i className="fal fa-times"></i>
              </button>
            </div>
            <div className="tpoffcanvas__logo text-center">
              <a href="index.html">
                <img src="/img/logo/billwale_white_logo.png" alt="" />
              </a>
            </div>
            <div className="mobile-menu"></div>
            <div className="tpoffcanvas__instagram text-center">
              <div className="tpoffcanvas__instagram-title">
                <h4>instagram</h4>
              </div>
              <a href=".">
                <img src="/img/project/project-inner-4.jpg" alt="" />
              </a>
              <a href=".">
                <img src="/img/project/project-inner-5.jpg" alt="" />
              </a>
              <a href=".">
                <img src="/img/project/project-inner-6.jpg" alt="" />
              </a>
              <a href=".">
                <img src="/img/project/project-inner-7.jpg" alt="" />
              </a>
            </div>

            <div className="tpoffcanvas__social">
              <div className="social-icon text-center">
                <a href=".">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href=".">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href=".">
                  <i className="fab fa-facebook-square"></i>
                </a>
                <a href=".">
                  <i className="fab fa-dribbble"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="body-overlay"></div>
        {/* <!-- tp-offcanvus-area-end --> */}

        <div id="smooth-wrapper">
          <div id="smooth-content">
            <main className="fix">

              {/* <!-- tp-slider-area-start --> */}
              <div className="tp-hero-area tp-hero-pt pt-170 pb-70 p-relative">
                <div className="tp-hero-left-shape">
                  <img src="/img/hero/hero-left-shape-3-1.png" alt="" />
                </div>
                <div className="tp-hero-gradient-bg">
                  <img src="/img/hero/hero-gradient_1.jpg" alt="" />
                </div>
                <div className="container">
                  <div className="row justify-content-center z-index-3">
                    <div className="col-xl-11">
                      <div className="tp-hero-title-box text-center">
                        <h2 className="tp-hero-title-3 hero-text-anim">
                          Great
                          <span> Invoicing</span>
                          <br />
                          <div className="mt-5">Service Start Here.</div>
                        </h2>
                        <p className="tp-char-animation-2">
                          Billwale Provides Invoicing & Inventory Management
                          <br />
                          Service For All Kind Of Business And Devices.
                        </p>
                      </div>
                      <div className="tp-hero-btn-3 text-center wow tpfadeUp" data-wow-duration=".9s"
                        data-wow-delay=".7s">
                        <a className="tp-btn-blue-lg tp-btn-hover alt-color-black" href="#exampleModal">
                          <span><button className="border-0 bg-transparent" type="button" data-bs-toggle="modal"
                            data-bs-target="#exampleModal">
                            Live Demo
                          </button></span>
                          <b></b>
                        </a>
                        <a className="tp-btn-border tp-btn-hover alt-color-black" target="_blank" rel="noreferrer" href="https://app.billwale.com/login">
                          <span>Try for Free</span>
                          <b></b>
                        </a>
                      </div>

                      <div className="Header__logo d-flex w-100 mx-auto">
                        <div className="billwale-header-logo text-center">
                          <a href=".">
                            <div>
                              <img
                                unselectable="on"
                                src="/img/logo/billwale_logo.png"
                                alt=""
                              />
                            </div>
                          </a>
                        </div>
                        <div className="Playstore-lable text-center d-flex">
                          <a href="https://play.google.com/store/apps/details?id=com.billwale" target="_blank" rel="noreferrer">
                            <div className="d-flex">
                              <div className="play-lgo-holder">
                                <img src="/img/logo/playstore (1).png" alt="" />
                              </div>
                              <div className="Play-con ms-2 ms-md-4">
                                <p className="">Get It On</p>
                                <p className="mt-1">Google Play</p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>

                      <div className="tp-hero-3-wrapper p-relative">
                        <div className="tp-hero-3-border-wrap d-none d-md-block">
                          <span className="redius-shape-1"></span>
                          <span className="redius-shape-2"></span>
                          <span className="redius-shape-3"></span>
                        </div>
                        <div className="tp-hero-3-main-thumb z-index-5">
                          <img src="/img/hero/dashboard.png" alt="" />
                        </div>
                        <div className="tp-hero-3-shape-5 d-none d-lg-block wow frist-img animated">
                          <img src="/img/hero/hero-img-3-1-3.png" alt="" />
                        </div>
                        <div className="tp-hero-3-shape-6 d-none d-lg-block">
                          <span>
                            <svg
                              width="64"
                              height="202"
                              viewBox="0 0 64 202"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                className="line-2"
                                d="M63.0029 7.94799C45.0715 -0.936415 14.5884 -8.38783 36.1059 32.8816C63.0029 84.4681 71.2089 85.3283 36.1059 75.8707C1.00293 66.4131 15.5915 92.2063 36.1059 118C56.6205 143.794 57.0764 169.587 28.3558 152.391C-0.364664 135.195 1.00293 144.653 28.3558 179.904C55.7087 215.155 22.4293 195.38 1.00293 196.24"
                                stroke="#202124"
                                strokeWidth="2"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- tp-slider-area-end --> */}

              {/* <!-- tp-counter-area-start --> */}
              <div className="tp-counter-area tp-counter-space p-relative pb-140">
                <div className="tp-counter-shape-2">
                  <img src="/img/counter/counter-shape-2.png" alt="" />
                </div>
                <div className="tp-counter-shape-3">
                  <img src="/img/counter/counter-shape-1.png" alt="" />
                </div>
                <div className="tp-counter-shape-4 d-none d-sm-block">
                  <img src="/img/counter/counter-shape-4.png" alt="" />
                </div>
                <div className="container">
                  <div className="tp-counter-wrapper p-relative">
                    <div className="d-flex justify-content-around gx-0">
                      <div className="col-xl-4 col-lg-4 col-md-4">
                        <div className="tp-counter-wrap d-flex justify-content-center">
                          <div className="tp-counter-item">
                            <h4>
                              <span
                                data-purecounter-duration="1"
                                data-purecounter-end="350"
                                className="purecounter"
                              >
                                350
                              </span>
                              +
                            </h4>
                            <p>Team Members</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-4">
                        <div className="tp-counter-wrap d-flex justify-content-center">
                          <div className="tp-counter-item">
                            <h4>
                              <span
                                data-purecounter-duration="1"
                                data-purecounter-end="10"
                                className="purecounter"
                              >
                                10
                              </span>
                              <em>m</em>+
                            </h4>
                            <p>Total funding</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-4">
                        <div className="tp-counter-wrap border-0 d-flex justify-content-center">
                          <div className="tp-counter-item">
                            <h4>
                              <span
                                data-purecounter-duration="1"
                                data-purecounter-end="500"
                                className="purecounter"
                              >
                                500
                              </span>
                              <em>k</em>
                            </h4>
                            <p>Total active user base</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- tp-counter-area-end --> */}

              {/* <!-- tp-service-area-strat --> */}
              <div className="tp-service-area pb-90 z-index">
                <div className="container">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="tp-service-section-wrapper mb-60 d-flex justify-content-between align-items-end">
                        <h3
                          className="tp-section-title-3 wow tpfadeLeft"
                          data-wow-duration=".9s"
                          data-wow-delay=".3s"
                        >
                          Inventory Software <br /> That{" "}
                          <span>Manages All.</span>
                        </h3>
                        <a
                          className="tp-btn-blue-lg tp-btn-hover mb-10 alt-color-black wow tpfadeRight"
                          data-wow-duration=".9s"
                          data-wow-delay=".5s"
                          href="."
                        >
                          <span>See All Features</span>
                          <b></b>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div
                      className="col-xl-8 wow tpfadeLeft"
                      data-wow-duration=".9s"
                      data-wow-delay=".5s"
                    >
                      <div
                        className="tp-service-3-item p-relative mb-30 z-index"
                        data-background="/img/service/service-3-bg.png"
                        style={{
                          backgroundImage: "url(/img/service/service-3-bg.png)",
                        }}
                      >
                        <div className="billwale_logo">
                          <img
                            className="position-absolute"
                            src="/img/service/billwale logo.png"
                            alt=""
                          />
                        </div>
                        <div className="iso_img">
                          <img
                            className="position-absolute"
                            src="/img/service/iso.png"
                            alt=""
                          />
                        </div>
                        <div className="human_img">
                          <img
                            className="position-absolute"
                            src="/img/service/human_img.png"
                            alt=""
                          />
                        </div>
                        <div className="content_img">
                          <img
                            className="position-absolute px-5 rounded-5 rounded-bottom"
                            src="/img/service/Billwale.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    {/* <!-- > 1 Create GST/ Non GST Bills. --> */}
                    <div
                      className="features-block col-xl-4 col-md-6 col-xs-2 col-lg-6 wow tpfadeRight"
                      data-wow-duration=".9s"
                      data-wow-delay=".6s"
                    >
                      <div className="tp-service-sm-item mb-30 d-flex flex-column justify-content-between">
                        <div className="tp-service-sm-icon text-center">
                          <img
                            src="/img/four-card-img/Business_Accounting_and_Banking_Services_35_.jpg"
                            alt=""
                          />
                        </div>
                        <div className="tp-service-sm-content">
                          <button
                            type="button"
                            className="border-0 text-start"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal1"
                          >
                            <span>Easy Invoicing</span>
                            <h3 className="tp-service-sm-title">
                              <a href=".">Create GST/ Non GST Bills.</a>
                            </h3>
                            <div className="tp-service-sm-link">
                              <p>
                                Learn More{" "}
                                <i className="fa-solid fa-arrow-right"></i>
                                {/* <i className="far fa-arrow-right"></i> */}
                              </p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* <!-- > 2 Manage Inventory Efficiently --> */}
                    <div
                      className="features-block col-xl-4 col-md-6 col-xs-2 col-lg-6 wow tpfadeUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".5s"
                    >
                      <div className="tp-service-sm-item mb-30 d-flex flex-column justify-content-between">
                        <div className="tp-service-sm-icon manage_img text-center">
                          <img
                            src="/img/four-card-img/analyze_shipments.jpg"
                            alt=""
                          />
                        </div>
                        <div className="tp-service-sm-content">
                          <button
                            type="button"
                            className="border-0 text-start"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal2"
                          >
                            <span>Inventory Management</span>
                            <h3 className="tp-service-sm-title">
                              <a href=".">Manage Inventory Efficiently</a>
                            </h3>
                            <div className="tp-service-sm-link">
                              <p>
                                Learn More{" "}
                                <i className="fa-solid fa-arrow-right"></i>
                                {/* <i className="far fa-arrow-right"></i> */}
                              </p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* <!-- > 3 Get Real Time Analytics. --> */}
                    <div
                      className="features-block col-xl-4 col-md-6 col-xs-2 col-lg-6 wow tpfadeUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".7s"
                    >
                      <div className="tp-service-sm-item mb-30 d-flex flex-column justify-content-between">
                        <div className="tp-service-sm-icon text-center">
                          <img
                            src="/img/four-card-img/company_data_analysis_time_warning.jpg"
                            alt=""
                          />
                        </div>
                        <div className="tp-service-sm-content">
                          <button
                            type="button"
                            className="border-0 text-start"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal3"
                          >
                            <span>Business Analytics</span>
                            <h3 className="tp-service-sm-title">
                              <a href=".">
                                Get Real Time <br />
                                Analytics.
                              </a>
                            </h3>
                            <div className="tp-service-sm-link">
                              <p>
                                Learn More{" "}
                                <i className="fa-solid fa-arrow-right"></i>
                                {/* <i className="far fa-arrow-right"></i> */}
                              </p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* <!-- > 4 Quick E-Invoicing & E-Way Bill Generate --> */}
                    <div
                      className="features-block col-xl-4 col-md-6 col-xs-2 col-lg-6 wow tpfadeUp"
                      data-wow-duration=".9s"
                      data-wow-delay=".9s"
                    >
                      <div className="tp-service-sm-item mb-30 d-flex flex-column justify-content-between">
                        <div className="tp-service-sm-icon eway_img text-center">
                          <img src="/img/four-card-img/eway.png" alt="" />
                        </div>
                        <div className="tp-service-sm-content">
                          <button
                            type="button"
                            className="border-0 text-start"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal4"
                          >
                            <span>Quick E-Way Bill</span>
                            <h3 className="tp-service-sm-title">
                              <a href=".">
                                Quick E-Invoicing & E-Way Bill Generate
                              </a>
                            </h3>
                            <div className="tp-service-sm-link">
                              <p>
                                Learn More{" "}
                                <i className="fa-solid fa-arrow-right"></i>
                                {/* <i className="far fa-arrow-right"></i> */}
                              </p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- tp-service-area-end --> */}

              {/* <!-- tp-rated-area-start --> */}
              <div className="tp-rated-area fix p-relative">
                <div
                  className="tp-rated-bg pt-120"
                  data-background="/img/rate/rated-bg.jpg"
                  style={{ backgroundImage: "url(/img/rate/rated-bg.jpg)" }}
                >
                  <div className="tp-rated-shape-1 d-none d-lg-block">
                    <img src="/img/rate/rate-shape-1.png" alt="" />
                  </div>
                  <div className="tp-rated-shape-2 d-none d-sm-block">
                    <img src="/img/rate/rate-shape-2.png" alt="" />
                  </div>
                  <div className="container z-index-6">
                    <div className="row justify-content-center">
                      <div className="col-xl-10">
                        <div className="tp-rated-title-box text-center mb-60">
                          <div className="tp-rated-icon tp-title-anim">
                            <img
                              src="/img/rate/5_star-removebg-preview.png"
                              alt=""
                            />
                          </div>
                          <h5 className="tp-section-title-3 text-white mt-3 pb-40">
                            Customers have
                            <span>Consistently </span>
                            <br />
                            <span>Rated</span> Billwale<span> 4.9/5</span>
                          </h5>
                          <a
                            className="tp-btn-blue-lg tp-btn-hover alt-color-white"
                            href="contact.html"
                          >
                            <span className="text-color-black">
                              Try it on Browser
                            </span>
                            <b></b>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="author-rated-wrapper">
                      <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-4">
                          <div className="author-rated text-center">
                            <div className="author-rated-icon">
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                            </div>
                            <p>"the interface is excellent"</p>
                            <div className="author-rated-logo">
                              <img src="/img/rate/rate-logo-1.png" alt="" />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4">
                          <div className="author-rated text-center">
                            <div className="author-rated-icon">
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                            </div>
                            <p>"the interface is excellent"</p>
                            <div className="google_logo">
                              <img src="/img/rate/rate-logo-3.png" alt="" />
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4">
                          <div className="author-rated text-center">
                            <div className="author-rated-icon">
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                              <span>
                                <i className="fas fa-star"></i>
                              </span>
                            </div>
                            <p>"improvements in every release"</p>
                            <div className="author-rated-logo">
                              <img src="/img/rate/rate-logo-2.png" alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="author-rated-big-img"
                      data-parallax='{"y": 100, "smoothness": 30}'
                    >
                      <img src="/img/rate/rated-img.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- tp-rated-area-end --> */}

              {/* <!-- tp-card-area-start --> */}
              <div className="tp-card-area tp-card-space pt-175 pb-65">
                <div className="container">
                  <div className="row">
                    <div
                      className="col-xl-6 col-lg-6 wow tpfadeLeft"
                      data-wow-duration=".9s"
                      data-wow-delay=".5s"
                    >
                      <div className="tp-card-thumb-wrapper p-relative">
                        <div className="tp-card-main-img">
                          <img src="/img/card/Billwale-Banner.png" alt="" />
                        </div>
                        <div className="tp-card-img-1">
                          <img src="/img/card/card-shape-1.png" alt="" />
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xl-6 col-lg-6 wow tpfadeRight"
                      data-wow-duration=".9s"
                      data-wow-delay=".7s"
                    >
                      <div className="tp-card-title-box">
                        <h3 className="tp-section-title-3 pb-15">
                          Manage <span>All your Invoices & Expenses</span> in
                          one place.
                        </h3>
                        <p>
                          Whether your require multiple users or multiple
                          invoice themes,
                          <br />
                          Billwale is best for every Business.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- tp-card-area-end --> */}

              {/* <!-- tp-sales-area-start --> */}
              <div className="tp-sales-area tp-sales-space">
                <div className="container">
                  <div className="row align-items-center">
                    <div
                      className="col-xl-6 col-lg-6 wow tpfadeLeft"
                      data-wow-duration=".9s"
                      data-wow-delay=".5s"
                    >
                      <div className="tp-sales-section-box pb-20">
                        <h3 className="tp-section-title-3">
                          Track and <span>Analyze Sales</span> in Real time
                        </h3>
                        <p className="tp-title-anim">
                          Simplified & user friendly smart dashboard to made
                          your <br />
                          business easy from busy.
                        </p>
                      </div>
                      <div className="tp-sales-feature">
                        <ul>
                          <li className="yellow-1">
                            <span>
                              <i className="far fa-check"></i>{" "}
                              <em>No Hidden Fees.</em>
                            </span>
                          </li>
                          <li className="purple-2">
                            <span>
                              <i className="far fa-check"></i>{" "}
                              <em>100% Data Security</em>
                            </span>
                          </li>
                          <li className="green-3">
                            <span>
                              <i className="far fa-check"></i>{" "}
                              <em>Best For All Kind Of Business</em>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div
                      className="tp-sales-right col-xl-6 col-lg-6 wow tpfadeRight"
                      data-wow-duration=".9s"
                      data-wow-delay=".7s"
                    >
                      <div className="tp-sales-img-wrapper p-relative">
                        <div className="tp-sales-sub-img-1 d-none d-md-block">
                          <img src="/img/card/sale-2.png" alt="" />
                        </div>
                        <div className="tp-card-img-2 d-none d-sm-block">
                          <img src="/img/card/card-img-1.png" alt="" />
                        </div>
                        <div
                          className="tp-card-img-3 d-none d-md-block"
                          data-parallax='{"x": 50, "smoothness": 30}'
                        >
                          <img src="/img/card/card-img-2.png" alt="" />
                        </div>
                        <div
                          className="tp-card-img-4 d-none d-md-block"
                          data-parallax='{"x": -50, "smoothness": 30}'
                        >
                          <img src="/img/card/card-img-3.png" alt="" />
                        </div>
                        <div className="tp-card-img-5 d-none d-sm-block">
                          <img src="/img/card/card-img-4.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- tp-sales-area-end --> */}

              {/* <!-- tp-integration-area-start --> */}
              {/* <div id="features" className="tp-integration-area pb-110 tp-integration-mlr">
                <div className="container">
                  <div className="row align-items-end tp-integration-section-space">
                    <div className="col-xl-6 col-lg-8 wow tpfadeLeft" data-wow-duration=".9s" data-wow-delay=".5s">
                      <div className="tp-integration-section-box">
                        <h3 className="tp-section-title-3"> Our<span> Features</span>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tp-integration-slider-wrapper pt-50 pb-50"
                  data-background="assets/img/integration/integration-bg.jpg" style={{ backgroundImage: "url(/img/integration/integration-bg.jpg)" }}>

                  <div className="tp-integration-slider-active mb-30">
                    <FeaSliderOne />
                  </div>
                  <div className="tp-integration-slider-active ">
                    <FeaSliderTwo />
                  </div>
                </div>
              </div> */}
              {/* <!-- tp-integration-area-end --> */}

            </main>

            <div className="home-footer">
              <Footer />
            </div>

          </div>
        </div>
        {/* <!-- tp-sales-area-end --> */}
      </section>
    </>
  );
}
